import styled from "styled-components";
import { color } from "../../../../shared/styles";

export const CustomerInfoWrapper = styled.div`
    background-color: white;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.08);
    padding: 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 24px;
    border-radius: 16px;
`;

export const TitleWrapper = styled.div`
    display: flex;
    gap: 16px;
    width: 100%;
    align-items: center;
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`;

export const SeparateLine = styled.div`
    height: 1px;
    width: 100%;
    background-color: ${color.secondary.BORDER};
`;
